module.exports = __webpack_public_path__ + "static/img/img2.987a6103.png";